module.exports = __webpack_public_path__ + "static/media/oxo.74c8db95.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/registry/aboutZolaBrands/oxo.png
 ** module id = 2420
 ** module chunks = 44
 **/